import { FormBase } from 'core/components';

export default class ReplacementForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'replacementReasonId',
					label: 'REPLACEMENTVIEW.REPLACEMENTREASON',
					rules: 'required',
				},
			],
		};
	}
}
